<template>
  <VListGroup
    v-if="appAllowAccess(authenticated, roles, permissions) && ($attrs.debug ? isAppDebugMode : true)"
    :prepend-icon="icon"
    :title="title"
  >
    <template #activator>
      <VListItemTitle>
        {{ title }}
        <div
          v-if="custom"
          v-html="custom"
        />
      </VListItemTitle>

    </template>

    <NavItem
      v-bind="item"
      v-for="item in child"
      :key="item.title + Date.now()"
    />
  </VListGroup>
</template>

<script>
import NavItem from '@/components/layouts/Sidebar/NavItem.vue'
import AppUtils from '@/utils/AppUtils'

export default {
  components: {
    NavItem
  },
  props: {
    child: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'mdi-circle'
    },
    color: {
      type: String,
      default: 'primary'
    },
    custom: {
      type: String,
      default: ''
    },
    authenticated: {
      type: Boolean,
      default: false
    },
    roles: {
      type: Array,
      default: () => []
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isAppDebugMode () {
      return AppUtils.isDebugMode()
    },
  },
  methods:{
    appAllowAccess (authenticated = false, roles = [], permissions = []) {
      return AppUtils.allowAccess(authenticated, roles, permissions)
    },
  }
}
</script>
